import Swiper from 'swiper'

export default class ImageLinkSlider {
  constructor(component) {
    this.dom = {
      $component: component
    }
    this.state = {

    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    this.initSlider()
  }

  initSlider() {
    const swiper = new Swiper('.js-imageLinkSlider', {
      slidesPerView: 'auto',
      breakpoints: {
        1024: {
          allowTouchMove: false
        }
      }
    })
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.ImageLinkSlider = this
  }
}
